/**
 * ReCAPTCHA v3 frontend round
 * 
 * @param {object} options - Optional settings
 * @param {string} [options.action=submit] - Custom recaptcha v3 action
 * 
 * @returns {Promise<string>}
 */
export const captcha = (options = {}) => {
  const _defaults = {
    action: 'submit',
  };
  const opts = { ..._defaults, ...options };

  return new Promise((resolve, reject) => {
    if (!Settings.recaptcha.enabled) {
      return resolve('');
    }
    if (Settings.recaptcha.enabled && typeof grecaptcha === 'undefined') {
      return reject('Invalid recaptcha configuration.');
    }
    grecaptcha.ready(() => {
      grecaptcha.execute(Settings.recaptcha.site_key, {
        action: opts.action
      })
        .then(token => {
          resolve(token);
        })
        .catch(err => {
          reject(err);
        });
    });
  });
};
